const sec = 1_000; // ms
export const min = 60 * sec;
const hour = 60 * min;

/** Minimum age of a loaded coupon before a window-focus revalidation re-fetches it. */
export const PROMOCODE_REVALIDATE_TTL = 5 * min;

export const PICKUP_ALCOHOL_COUPON_CODE = 'COLLECT';

/**
 * Stable machine-readable promocode rejection reasons for analytics.
 * Client-side validation failures use these codes; server failures pass through
 * the raw `err_code`. Keep values stable — they are consumed by BI/Amplitude.
 */
export const PROMOCODE_ERROR_CODE = {
  NOT_ACTIVE: 'NOT_ACTIVE',
  DENIED_DISCOUNTED_ITEMS: 'DENIED_DISCOUNTED_ITEMS',
  MINIMUM_PURCHASE: 'MINIMUM_PURCHASE',
  PICKUP_NOT_AVAILABLE: 'PICKUP_NOT_AVAILABLE',
  // Backend applied the promocode to nothing. Usually arrives as a server
  // `promocodeError`, but on some calculations the backend echoes
  // `promocode: null` with no error — we synthesize this code so the outcome
  // is surfaced consistently. Value matches the `errors:` i18n key.
  NO_ITEM_APPLIED: 'PROMOCODE_NO_ITEM_APPLIED',
  UNKNOWN: 'UNKNOWN',
} as const;

export const CURRENCY_SYMBOL: Record<string, string> = {
  gbp: '£',
  usd: '$',
  kwd: 'KD ',
  aed: '\uf101',
  egp: 'EGP',
  idr: 'IDR',
  isk: 'ISK',
  rub: '₽',
};

export const PURCHASED_ITEMS_COUNT = 20;
export const REQUEST_STRIPE_CONFIRM_TIMEOUT = 10 * sec; // ms
export const PAYMENT_TIMEOUT = 10 * min; // ms
/**
 * How long a wallet payment may stay silent before it is reported — without
 * being abandoned.
 *
 * {@link PAYMENT_TIMEOUT} is the right ceiling for giving up, but useless as
 * evidence: ten minutes in, the customer has usually already retried, and every
 * retry overwrites the active payment intent, so the late timeout resolves
 * against a stale `client_secret` and its report never reaches Sentry. One
 * CityDrinks customer created four orders in four minutes and left a single
 * event behind. Forty-five seconds is well past a Face ID prompt and still
 * inside the attempt being described.
 */
export const PAYMENT_STALL_REPORT_AFTER = 45 * sec; // ms
export const PAYMENT_WAITING_TIME = 120; // sec

export const ANALYTICS_PRODUCTS_SHOWN_INTERVAL = min; // ms
export const REQUEST_ETA_INTERVAL = min; // ms
export const REQUEST_ORDER_STATUS_INTERVAL = 30 * sec; // ms
export const CATEGORIES_CACHE_DURATION = 3 * min; // ms
export const BANNERS_SLIDER_DURATION = 5 * sec; // ms
export const CATEGORY_CACHE_DURATION = 3 * min; // ms
export const PRODUCT_CACHE_DURATION = 2 * min; // ms
export const ALERT_DURATION = 5 * sec; // ms
export const OUTDATED_APP_POPUP_INTERVAL = 24 * hour; // ms

export const PRODUCT_DESCRIPTION_LENGTH = 135;
export const PRODUCT_SELLABLE_LIMIT = 10;
export const BUNDLE_SELLABLE_LIMIT = 5;
export const PRESENT_PROMOCODES: string[] = [];
export const PRESENT_PROMOCODES_DATA: Record<
  string,
  { storeAllowed: string[] }
> = {};
export const PRESENT_PROMOCODES_ORDERS_LIMIT = 1;
export const SEARCH_CATEGORY_STANDARD_LENGTH = 5;
export const SEARCH_PRODUCTS_STANDARD_LENGTH = 30;
export const REMAIN_MINUTES_BEFORE_CLOSE_POPOVER = 10;
export const SESSION_STORAGE = {
  BLINK_ACTION_CALLED: 'BLINK_ACTION_CALLED',
};

export const GOOGLE_API_KEY = import.meta.env.REACT_APP_GOOGLE_API_KEY;

export const YANDEX_MAP_API_KEY = import.meta.env.REACT_APP_YANDEX_MAP_API_KEY;
